import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
// import { localStorageService } from 'src/app/services/shared.service';
import * as REGEX from '../../../shared/regex';
import { MainService } from 'src/app/services/main.service';
import { Router } from '@angular/router';
import { CaptchaService } from 'src/app/services/captcha.service';
import { SharedService, countryData } from 'src/app/services/shared.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { environment } from 'src/environments/environment';
import { localStorageService } from 'src/app/services/localstorage.service';
import { LeftLayoutComponent } from '../left-layout/left-layout.component';
import { NgxMaskDirective } from 'ngx-mask';
import { DatePipe } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LogoutModalComponent } from 'src/app/shared/logout-modal/logout-modal.component';

@Component({
    selector: 'app-verify-phone-number',
    templateUrl: './verify-phone-number.component.html',
    styleUrl: './verify-phone-number.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LeftLayoutComponent, FormsModule, ReactiveFormsModule, NgxMaskDirective, DatePipe]
})
export class VerifyPhoneNumberComponent {
  step = {
    MOBILE_NUMBER: 'MOBILE_NUMBER',
    VERIFY_OTP: 'VERIFY_OTP',
  };
  selectedStep = this.step.MOBILE_NUMBER;
  verifyForm: UntypedFormGroup;
  otpForm: UntypedFormGroup;
  // localStorageSer: any;
  mask = '(000) 000-0000';
  otpValueGroup = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  otp_id = 0;
  countries: countryData[] = [];
  country_data: any;
  last4Number: string = '';
  countdown: number = 180; // Countdown starts from 30 seconds
  countdownInterval: any;
  bsModalRef: BsModalRef | undefined;

  constructor(
    private fb: UntypedFormBuilder,
    private apiSer: ApiService,
    private router: Router,
    private cs: CaptchaService,
    public _shared: SharedService, // temporary need to hide
    private _loader: LoaderService,
    private _local: localStorageService,
    public mainService: MainService,
    private modalService: BsModalService,
  ) {
    this.verifyForm = this.fb.group({
      doctor_mobile: ['', [Validators.required, Validators.pattern(REGEX.number_regex), Validators.minLength(10), Validators.maxLength(15),
      ],
      ],
    });
    this.otpForm = this.fb.group({
      first: ['', [Validators.required, Validators.maxLength(1)]],
      second: ['', [Validators.required, Validators.maxLength(1)]],
      third: ['', [Validators.required, Validators.maxLength(1)]],
      fourth: ['', [Validators.required, Validators.maxLength(1)]],
      fifth: ['', [Validators.required, Validators.maxLength(1)]],
      sixth: ['', [Validators.required, Validators.maxLength(1)]],
    });
    this._shared.country_data$.subscribe(countries => {
      this.countries = countries;
    })
    this._shared.country_currency_info$.subscribe(data => {
      if (data && data.country) {
        this.country_data = data.country;
      }
    });
  }
  ngOnInit(){
    const token = this._local.customGetItem('token');

    if (token !== null && token !== undefined) {
      this.mainService.accessTokenLogin()
    }
  }
  async verifyPhoneNumber() {

    if (this.verifyForm.invalid) {
      this.verifyForm.markAllAsTouched();
      this.verifyForm.markAsDirty();
      return;
    }
    try {
      let data;
      this._loader.showLoader();
      const mobileNumber = this.verifyForm.controls['doctor_mobile'].value + '';
      this.last4Number = mobileNumber.substring(mobileNumber.length - 4, mobileNumber.length);
      const captcha = await this.cs.getCaptchaToken();
      // console.log('Captcha token:', token);
      data = {
        doctor_mobile: mobileNumber,
        captcha,
        doctor_mobile_country_code: (this.countries && this.countries[0] && this.countries[0]['mobile_code'] || '+1')
      };
      this.apiSer.api(data, 'profile/send_otp').subscribe((data) => {
        if (data.is_error == 0) {
          if (data.otp_id) {
            this.otp_id = data.otp_id;
          }
          this.selectedStep = this.step.VERIFY_OTP;
          if (data.otp && !environment.production) {
            this._shared.customPopups(data.otp, 0);
          }
          this.startCountdown();
          this.countdown = 180
          this.otpForm.reset();
        } else {
          this.verifyForm.markAsDirty();
          this.verifyForm.markAsTouched();
          window.scroll(0, 0);
        }
      });
    } catch (error) {
      console.error('Failed to get captcha token', error);
      return;
    }
    // console.log(data);
  }

  onInput(event: any, currentIndex: number,method:any=''): void {
    const inputValue = method=='paste'?event:event.target.value;
    console.log( typeof inputValue);
    if (!(inputValue >= 0) || !(inputValue < 10) ) {
      this.otpForm.get(this.otpValueGroup[currentIndex])?.setValue('');
      return;      
    }
    if (inputValue && (currentIndex < (this.otpValueGroup.length - 1))) {
      const nextInput = this.otpValueGroup[currentIndex + 1];
      this.setFocus(nextInput);
    }
  }

  onPasteHandler(data:any){
    if(data<=999999){
      let splitData=data.split('')
        for(let i=0;i<splitData.length;i++){
          this.otpForm.controls[this.otpValueGroup[i]].patchValue(splitData[i]);
        }
        this.onInput(splitData[splitData.length-1],splitData.length-2,'paste') 
    }
    
  }

  onDelete(event: any, currentIndex: number): void {
    if (!event.target.value && currentIndex > 0) {
      const previousInput = this.otpValueGroup[currentIndex - 1];
      this.setFocus(previousInput);
    }
  }

  setFocus(input: string) {
    if (input) {
      document.getElementById(input)?.focus();
    }
  }

  verifyOtp() {
    if (this.otpForm.invalid) {
      this.otpForm.markAsDirty();
      this.otpForm.markAllAsTouched();
      return;
    }
    let data;
    let value = '';
    this.otpValueGroup.filter(input => value += this.otpForm.value[input]);
    data = {
      otp: value,
      otp_id: this.otp_id
    };
    this.apiSer.api(data, 'profile/verify_otp').subscribe((data) => {
      if (data.is_error == 0) {
        this.router.navigate(['business-info']);
      } else {
        this.otpForm.markAsDirty();
        this.otpForm.markAsTouched();
        window.scroll(0, 0);
      }
    });
  }

  startCountdown(): void {

    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownInterval); 
      }
    }, 1000); 
  }

  renewOtp(): void {
    // Generate a new OTP and reset countdown
    this.verifyPhoneNumber();
    this.countdown = 180; // Reset countdown to 180 seconds
 
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  get f() {
    return this.otpForm.controls;
  }

  logoutModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(LogoutModalComponent, {
      initialState,
      class: 'modal-dialog-centered'
    });
  }
}
